import {
  SET_TOTAL_MONEY,
  RESET_TOTAL_MONEY,
  RESET_TOTAL_TIME,
  SET_TOTAL_TIME,
  SET_CHOOSEN_ITEMS,
  SET_MASTER,
  SET_MASTER_LIST,
  AUTH_SUCCES,
  AUTH_LOGOUT,
  PHONES_SET,
  MODAL_SET,
  SET_MODAL_CONTENT,
} from "../actions/actionTypes";

const initialState = {
  master: 0,
  choosenItems: new Set(),
  totalMoney: 0,
  totalTime: 0,
  masterList: [],
  token: null,
  phones: [],
  isModal: false,
  modalContent: "finish",
  startTime: new Date(),
};

export default function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MASTER_LIST:
      return {
        ...state,
        masterList: action.masterList,
      };
    case SET_MODAL_CONTENT:
      return {
        ...state,
        modalContent: action.payload,
      };
    case SET_TOTAL_MONEY:
      return {
        ...state,
        totalMoney: action.totalMoney,
      };
    case RESET_TOTAL_MONEY:
      return {
        ...state,
        totalMoney: action.totalMoney,
      };
    case SET_TOTAL_TIME:
      return {
        ...state,
        totalTime: action.totalTime,
      };
    case RESET_TOTAL_TIME:
      return {
        ...state,
        totalTime: action.totalTime,
      };
    case SET_CHOOSEN_ITEMS:
      return {
        ...state,
        choosenItems: action.choosenItems,
      };
    case SET_MASTER:
      return {
        ...state,
        master: action.master,
      };
    case AUTH_SUCCES:
      return {
        ...state,
        token: action.token,
      };
    case AUTH_LOGOUT:
      return {
        ...state,
        token: null,
      };
    case PHONES_SET:
      return {
        ...state,
        phones: action.phones,
      };
    case MODAL_SET:
      return {
        ...state,
        isModal: action.isModal,
      };
    default:
      return state;
  }
}
